import React, { Component } from 'react'
import './ButtonBar.css';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import PreviewOutlinedIcon from '@mui/icons-material/PreviewOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Link, NavLink } from "react-router-dom";
import logout from '../../assets/images/logout.png';


export default class ButtonBar extends Component {
  render() {


    const handleLogout = async () => {
      const log = confirm("Are you sure you want to logout?");
      if (log) {
        try {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
            method: 'POST',
            credentials: 'include',
          });
        } catch {
          // proceed regardless
        }
        sessionStorage.removeItem('user');
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    };


    return (
      <div className='ButtonBar'>
        <div className='Print-icons'>
          <PrintOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></PrintOutlinedIcon>
          <PreviewOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></PreviewOutlinedIcon>
        </div>
        <div className='Save-icons'>
          <SaveOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></SaveOutlinedIcon>
          <SaveAsOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></SaveAsOutlinedIcon>
        </div>
        <div className='Util-icons'>
          <AddOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></AddOutlinedIcon>
          <NoteAltOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></NoteAltOutlinedIcon>
          <SearchOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></SearchOutlinedIcon>
          <DeleteOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></DeleteOutlinedIcon>
        </div>
        <div className='Move-icons'>
          <KeyboardDoubleArrowLeftOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></KeyboardDoubleArrowLeftOutlinedIcon>
          <KeyboardArrowLeftOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></KeyboardArrowLeftOutlinedIcon>
          <KeyboardArrowRightOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></KeyboardArrowRightOutlinedIcon>
          <KeyboardDoubleArrowRightOutlinedIcon className='Button-icon' sx={{ color: 'rgba(140, 140, 140, 1)', fontSize: '18px' }}></KeyboardDoubleArrowRightOutlinedIcon>
        </div>
        <div className='icons'>
          <RestartAltOutlinedIcon className='Button-icon-util' sx={{ color: '#810055', fontSize: '18px' }}></RestartAltOutlinedIcon>
          {/* <NavLink to={'/'}> */}
            <CloseOutlinedIcon className='Button-icon-util' sx={{ color: '#810055', fontSize: '18px' }} onClick={() => window.location.href = '/'}></CloseOutlinedIcon>
          {/* </NavLink> */}
          <img src={logout} alt='Logout' onClick={handleLogout} className='Button-icon-util' style={{width:'18px', height:'18px',cursor: "pointer"}}/>
        </div>
      </div>
    )
  }
}
